import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import InternalContext from './InternalContext';
import useStyleToClassName from '../hooks/internal/useStyleToClassName';
var ROOT_STYLE = {
  height: '100%',
  overflowY: 'auto',
  width: '100%'
};

var Panel = function Panel(_ref) {
  var children = _ref.children,
      className = _ref.className;

  var _useContext = useContext(InternalContext),
      setTarget = _useContext.setTarget;

  var rootCSS = useStyleToClassName()(ROOT_STYLE);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(rootCSS, (className || '') + ''),
    ref: setTarget
  }, children);
};

Panel.defaultProps = {
  children: undefined,
  className: undefined
};
Panel.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string
};
export default Panel;
